import { smartDashboardService } from "../../services";
import routePaths from "../routePaths";

const accessPageRequirements = {
  [routePaths.DASHBOARD]: smartDashboardService.getFeatureAvailability
};

export default accessPageRequirements;
